var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPdf = function SvgIconPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_pdf_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF481A",
    d: "M4.5 9h15a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1h-15V22a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5V7.25l-.23-.23h-2.98a2.3 2.3 0 0 1-2.3-2.3v-3l-.19-.21H5a.5.5 0 0 0-.5.5v7ZM3 19.5H1a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h2V2a2 2 0 0 1 2-2h12.4L24 6.6V22a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2.5Zm-.94-8.44v6.45h1.06v-2.49h1.6c1.56 0 2.36-.65 2.36-1.97 0-1.3-.8-1.99-2.35-1.99H2.06Zm1.06.92h1.54c.45 0 .8.07 1.01.25.21.17.33.43.33.82 0 .38-.1.66-.33.82-.2.17-.54.26-1 .26H3.11v-2.15Zm4.85-.92v6.45h2.34c1.06 0 1.83-.3 2.37-.87.52-.56.77-1.34.77-2.34 0-1.03-.25-1.83-.77-2.37-.54-.56-1.31-.87-2.37-.87H7.97Zm1.05.92h1.1c.8 0 1.39.18 1.76.54.35.37.54.96.54 1.78 0 .77-.19 1.36-.54 1.73-.37.38-.96.56-1.76.56h-1.1v-4.61Zm5.42-.92v6.45h1.05v-2.86h3.14v-.9H15.5v-1.77h3.33v-.92h-4.38Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_pdf_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconPdf;